import script from "./dynamicSkeleText.vue?vue&type=script&lang=js"
export * from "./dynamicSkeleText.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__